import React from 'react';
import './Soil.css';
import Menu from '../../Menu/Menu';
import b8 from '../../../img/soil2.jpg';
import b9 from '../../../img/soil3.jpg';
import b10 from '../../../img/gis2.jpg'



const Soil = () => {
    return (
        <div className='mb-5'>
            
            <div className='about4'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Soil Engineering</h1>
                </div>
            </div>

            <div id="gis">
                <h2 className='heading pt-5 px-3'>Soil Engineering</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3 mb-3'>
                        If you wants to build any buildings or structures at first you have to know
                        the soil behaviors of that’s place.<br></br>
                        Soil Engineering Part of “PROPER Design & Development Limited” provides
                        Soil testing purely ,analysis, interpretation and design.<br></br><br></br>
                        <strong>PROPER Design & Development </strong>Limited has been under taking site
                        investigations throughout the Bangladesh for over 5 years. Typical ground
                        investigation might include a desk study, boreholes, CPTs, trial pits, in-situ field
                        testing, geotechnical laboratory testing and contamination testing. This work
                        is coordinated by our technical team, made up Geotechnical Engineers and
                        Engineering Geologists. Geophysics. We provide surface, borehole and
                        offshore geophysical services as a cost-effective, non-intrusive approach for
                        site investigations. The integration of geophysics with traditional mappings,
                        intrusive sampling and other investigation methods can provide enhanced
                        understanding of site conditions resulting in reduced risks and lower project
                        costs.<br></br><br></br>
                        Our Geotechnical Investigation Service included but not limits to:<br></br>
                        <ol>
                            <li>
                                Borehole & SPT
                            </li>
                            <li>
                                Sample Collection
                            </li>
                            <li>
                                CPT
                            </li>
                            <li>
                                DCPT
                            </li>
                            <li>
                                CBR
                            </li>
                            <li>
                                Seismic Refraction Test
                            </li>
                            <li>
                                Pile Integrity Test (PIT) 
                            </li>
                            <li>
                                Load Test
                            </li>
                        </ol>
                            {/* <img src={b8} alt="" width="100%" className='me-2'/> */}
                        </div>
                        
                        <div className='col-lg-6 col-md-6 col-sm-12 px-lg-5'>
                            <div className='mt-3'>
                                    <img src={b8} alt="" width="100%" className='me-2 mb-3'/>
                                    <img src={b9} alt="" width="100%" className='me-2'/>
                                </div>
                        </div>
                    </div>
                </h5>
            </div>            
        </div>
    );
};

export default Soil;